const Pagination = ({ pagination, currentItemCount, loadMore, hideCounter, labels }) => {
  const total = pagination?.resultsAvailableCount
    ? pagination?.resultsAvailableCount
    : pagination?.total;

  return (
    total > 0 && (
      <div className="pagination">
        {!hideCounter && (
          <span>
            {new Intl.NumberFormat("it").format(currentItemCount)} {labels?.OF?.toLowerCase()}{" "}
            {new Intl.NumberFormat("it").format(total)}{" "}
            {total === 1 ? labels?.RESULT?.toLowerCase() : labels?.RESULTS?.toLowerCase()}
          </span>
        )}
        {currentItemCount < total && (
          <button className="button primary" onClick={loadMore}>
            {labels?.LOAD_MORE || "Load more"}
          </button>
        )}
      </div>
    )
  );
};

export default Pagination;
